<template>
    <div v-if="form.handle">
        <ValidationObserver v-slot="{ errors }" :ref="formId" :vid="formId" slim>
            <form @submit.prevent="submitForm" :id="formId" v-bind="attributes">
                <!-- Requirements -->
                <input type="hidden" id="action" name="action" value="freeform/api/form"/>
                <input type="hidden" name="formHash" :value="form.hash"/>
                <input type="hidden" :id="form.pot.name" :name="form.pot.name"
                       :value="form.pot.hash"/>
                <input type="hidden" :id="form.csrf.name" :name="form.csrf.name"
                       :value="form.csrf.value"/>

                <layout-normal :form="form" :instance="$data" :errors="errors"
                               v-if="layout === 'normal'"></layout-normal>
                <layout-slim :form="form" :instance="$data" :errors="errors" v-if="layout === 'slim'"></layout-slim>

                <div class="success-message" v-show="successMessage">{{ successMessage }}</div>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
    import axios from 'axios';
    import Helper from "./FormBuilder/Helper";
    import LayoutNormal from "./FormBuilder/Layouts/Normal";
    import LayoutSlim from "./FormBuilder/Layouts/Slim";

    export default {
        props: {
            init: {
                type: String,
                required: true,
            },
            layout: {
                type: String,
                required: false,
                default: 'normal',
            }
        },
        components: {
            LayoutNormal,
            LayoutSlim,
        },
        data() {
            return {
                formId: null,
                form: {},
                attributes: {
                    class: 'form vue-form-composer',
                    novalidate: 'true',
                    enctype: 'multipart/form-data',
                },
                sending: false,
                successMessage: null,
            }
        },
        methods: {
            submitForm: function (e) {
                this.$refs[this.formId].validate()
                    .then(success => {
                        if (!success) {
                            let errors = Object.entries(this.$refs[this.formId].fields).filter((value, key) => {
                                if (!value[1].valid) {
                                    return true;
                                }
                            });

                            const element = document.getElementById(errors[0][0]);

                            if (element) {
                                element.scrollIntoView({behavior: 'smooth', block: 'start'});
                            }
                        } else {
                            // Prevent multiple submissions
                            if (this.sending) return false;

                            this.sending = true;
                            const data = new FormData(document.getElementById(this.formId));

                            axios.post(window.location.href, data, {
                                headers: {
                                    'X-Requested-With': 'XMLHttpRequest',
                                    'HTTP_X_REQUESTED_WITH': 'XMLHttpRequest',
                                }
                            })
                                .then((response) => {
                                    if (response.data.success && response.data.finished) {
                                        if (this.form.ajax) {
                                            // Get the success message from the attribute
                                            for (let i = 0; i < this.form.attributes.length; i++) {
                                                if (this.form.attributes[i].attribute === 'data-success-message') {
                                                    this.successMessage = this.form.attributes[i].value;
                                                    break;
                                                }
                                            }

                                            // Fallback
                                            if (!this.successMessage) {
                                                this.successMessage = 'Thanks, we\'ve got your information!';
                                            }

                                            // Redirect if the URL is different
                                            if (response.data.returnUrl !== window.location.href.replace(window.location.origin, '')) {
                                                window.location = response.data.returnUrl;
                                            }
                                        } else if (response.data.returnUrl) {
                                            window.location = response.data.returnUrl;
                                        }

                                    }
                                })
                                .finally(() => {
                                    this.sending = false;
                                });
                        }
                    });
            },
            setupForm: function () {
                this.form = JSON.parse(this.$props.init);
                this.formId = 'vuejsForm-' + (this.form.attributes.id ? this.form.attributes.id : this.form.handle);

                this.attributes = Helper.setupAttributes(this.attributes, this.form.attributes);
            },
        },
        mounted() {
            this.setupForm();
        }
    }
</script>